import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import PATHS from '@/common/paths';
import { useMemo } from 'react';

export enum ServiceType {
  HIDDEN = 'HIDDEN',
}

interface ServicePayload {
  id: number;
  name: string;
  service_type?: ServiceType;
}

export const useServicesByIdQuery = (serviceId?: string) => {
  const { isLoading, isSuccess, isError, data } = useQuery<{ data?: ServicePayload }>(
    [PATHS.GET_SERVICES_BY_ID(serviceId), serviceId],
    () => api.get(PATHS.GET_SERVICES_BY_ID(serviceId)),
    {
      enabled: Boolean(serviceId),
    }
  );
  const isServiceHidden = useMemo(() => data?.data?.service_type === ServiceType.HIDDEN, [data]);

  return {
    isServiceHidden,
    isError,
    isLoading,
    isSuccess,
  };
};
